import { pathOr } from 'ramda'

export const selectIncidents = s => pathOr([], ['incidents', 'incidents'], s)
export const selectIncidentsLoading = s => pathOr(false, ['incidents', 'incidentsLoading'], s)
export const selectIncidentsMeta = s => pathOr(null, ['incidents', 'incidentsMeta'], s)
export const selectIncidentStats = s => pathOr(null, ['incidents', 'incidentStats'], s)
export const selectIncidentStatsLoading = s => pathOr(false, ['incidents', 'incidentStatsLoading'], s)
export const selectCurrentIncident = s => pathOr(null, ['incidents', 'currentIncident'], s)
export const selectCurrentIncidentLoading = s => pathOr(false, ['incidents', 'currentLoading'], s)
export const selectCurrentIncidentError = s => pathOr(null, ['incidents', 'currentError'], s)
export const selectSuggestions = s => pathOr(null, ['incidents', 'suggestions'], s)
export const selectSuggestionsLoading = s => pathOr(false, ['incidents', 'suggestionsLoading'], s)
export const selectIncidentMutationLoading = s => pathOr(false, ['incidents', 'mutationLoading'], s)
export const selectIncidentMutationError = s => pathOr(null, ['incidents', 'mutationError'], s)
